var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallazioneMotore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9996 22.4V16H55.9996V9.6H33.5996V16H41.5996V22.4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3996 43.2H7.99961V33.6H1.59961V59.2H7.99961V49.6H14.3996",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0004 32V40H67.2004V26.9488C67.2004 25.3216 65.9028 24 64.306 24H31.9844C31.218 24 30.4788 24.312 29.9364 24.8672L22.4004 33.6H17.6004C16.0004 33.6 14.4004 35.2 14.4004 36.8V56C14.4004 57.6288 16.0036 59.2 17.6004 59.2H22.4004L29.9396 67.9376C30.482 68.4896 31.218 68.8 31.9844 68.8H52.5524C53.3188 68.8 54.0548 68.4896 54.5972 67.9376L66.3508 55.9664C66.8964 55.4128 67.1988 54.664 67.1988 53.8816V49.6H71.9988V57.6H78.3988V32H72.0004Z",
    stroke: "black",
    strokeWidth: 2.0077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1992 44.8L38.3992 62.4L43.1992 48H35.1992L43.1992 32H51.1992L43.1992 44.8H51.1992Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallazioneMotore);
export default __webpack_public_path__ + "static/media/installazione_motore.66e269731b295a0bf36cdb8f30149861.svg";
export { ForwardRef as ReactComponent };